export const HOME_CSS = `

/* ── Hero ── */
.hp-hero {
  position: relative;
  height: 100vh;
  min-height: 560px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  background: var(--color-midnight);
}
.hp-hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(7,30,48,0.78) 0%,
    rgba(7,30,48,0.28) 40%,
    rgba(7,30,48,0.05) 100%
  );
  z-index: 1;
}
.hp-hero__content {
  position: relative;
  z-index: 2;
  padding: 0 6vw 64px;
  max-width: 960px;
}
.hp-hero__label {
  font-family: var(--font-sans);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--color-gold);
  margin-bottom: 16px;
}
.hp-hero__title {
  font-family: var(--font-serif);
  font-size: clamp(2.6rem, 5.5vw, 5rem);
  font-weight: 300;
  line-height: 1.05;
  color: var(--color-ivory);
  margin-bottom: 20px;
  letter-spacing: -0.01em;
}
.hp-hero__title em {
  font-style: italic;
  color: rgba(245,242,236,0.7);
}
.hp-hero__sub {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 300;
  color: rgba(245,242,236,0.6);
  line-height: 1.75;
  max-width: 600px;
}
.hp-hero__dots {
  position: absolute;
  bottom: 40px;
  right: 6vw;
  z-index: 2;
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.hp-hero__dot {
  width: 48px;
  height: 2px;
  background: rgba(245,242,236,0.25);
  border: none;
  cursor: pointer;
  padding: 0;
}
.hp-hero__scroll {
  position: absolute;
  bottom: 36px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  opacity: 0.45;
  pointer-events: none;
}
.hp-hero__scroll-line {
  width: 1px;
  height: 40px;
  background: var(--color-ivory);
  animation: hp-scroll-line 1.8s ease-in-out infinite;
}
@keyframes hp-scroll-line {
  0%   { transform: scaleY(0); transform-origin: top; }
  50%  { transform: scaleY(1); transform-origin: top; }
  51%  { transform: scaleY(1); transform-origin: bottom; }
  100% { transform: scaleY(0); transform-origin: bottom; }
}
.hp-hero__scroll-label {
  font-size: 9px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--color-ivory);
}

/* ── Section wrapper ── */
.hp-section { padding: 96px 0; }
.hp-section--ivory    { background: var(--color-ivory); }
.hp-section--white    { background: var(--color-white); }
.hp-section--offwhite { background: var(--color-off-white); }
.hp-section--midnight { background: var(--color-midnight); }
.hp-section--teal     { background: var(--color-teal); }
.hp-inner {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 20px;
}
.hp-eyebrow {
  font-family: var(--font-sans);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--color-gold);
  margin-bottom: 12px;
}
.hp-title {
  font-family: var(--font-serif);
  font-size: clamp(1.8rem, 3vw, 2.8rem);
  font-weight: 300;
  line-height: 1.15;
  color: var(--color-midnight);
  margin-bottom: 12px;
}
.hp-title--light { color: var(--color-ivory); }
.hp-sub {
  font-family: var(--font-sans);
  font-size: 14px;
  color: var(--color-slate);
  line-height: 1.7;
  margin-bottom: 12px;
  max-width: 480px;
}
.hp-sub--light { color: rgba(245,242,236,0.65); }
.hp-divider {
  width: 36px;
  height: 1px;
  background: var(--color-gold);
  margin: 16px 0 20px;
}

/* ── Cruise Section — Slick Carousel ── */
.crs2-section { padding: 66px 0 80px; }
.crs2-header {
  display: grid;
  grid-template-columns: 4fr 8fr;
  gap: 56px;
  align-items: start;
  margin-bottom: 48px;
}
.crs2-header__left { display: flex; flex-direction: column; align-items: flex-start; }
.crs2-header__left .hp-divider { margin-bottom: 28px; }
.crs2-header__btn { margin-top: 0; }
.crs2-intro {
  font-family: var(--font-sans);
  font-size: 0.9375em;
  font-weight: 300;
  color: var(--color-midnight);
  line-height: 1.2;
}
.crs2-intro h3 { line-height: 1.8; margin: 24px 0 12px; }
.crs2-intro p { margin: 0 0 10px; }
.crs2-intro p:last-child { margin-bottom: 0; }
.crs2-intro p strong { font-weight: 600; }
@media (max-width: 768px) {
  .crs2-header { grid-template-columns: 1fr; gap: 28px; }
}
.crs2-outer { position: relative; }

/* Slick overrides */
.crs2-outer .slick-slider { padding-bottom: 52px; }
.crs2-outer .slick-list   { overflow: hidden; padding: 14px 0 8px !important; }
.crs2-outer .slick-track  { display: flex; align-items: flex-end; }

/* Each slide */
.crs2-slide { padding: 0 12px; outline: none; }

/* Center slide scale */
.crs2-outer .slick-center .crs2-card {
  transform: scale(1.05);
  transform-origin: center center;
}

/* Card */
.crs2-card {
  display: flex;
  flex-direction: column;
  transition: transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Image: portrait 2:3, rounded corners */
.crs2-card__img-wrap {
  aspect-ratio: 2 / 3;
  overflow: hidden;
  background: #0B2236;
  margin-bottom: 14px;
  border-radius: 6px;
}
.crs2-card__img {
  width: 100%; height: 100%;
  object-fit: cover; display: block;
  transition: transform 0.6s ease;
}
.crs2-card__img-wrap:hover .crs2-card__img {
  transform: scale(1.04);
}
.crs2-card__img-fallback {
  width: 100%; height: 100%;
  background: linear-gradient(160deg, #0B2236 0%, #163a55 100%);
}

.crs2-card__link {
  display: flex; flex-direction: column;
  text-decoration: none; color: inherit;
}
.crs2-card__body {
  display: flex; flex-direction: column; gap: 5px;
  padding: 0 2px;
}
.crs2-card__brand {
  font-family: var(--font-sans);
  font-size: 9px; font-weight: 500;
  letter-spacing: 0.18em; text-transform: uppercase;
  color: var(--color-gold);
}
.crs2-card__title {
  font-family: var(--font-serif);
  font-size: 1rem; font-weight: 400;
  color: var(--color-midnight);
  line-height: 1.25;
}
.crs2-card__meta {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  margin-top: 2px; justify-content: space-between;
}
.crs2-stars { display: flex; gap: 2px; align-items: center; }
.crs2-card__cabins {
  display: inline-flex; align-items: center; gap: 4px;
  font-family: var(--font-sans);
  font-size: 10px; letter-spacing: 0.07em; text-transform: uppercase;
  color: var(--color-slate);
}
.crs2-card__cabins--day { color: var(--color-gold); }

/* Controls row */
.crs2-outer .slick-slider { padding-bottom: 0; }
.crs2-ctl {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 28px;
}
.crs2-arrow {
  width: 40px; height: 40px;
  flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  border: 1px solid transparent;
  background: transparent;
  color: var(--color-slate);
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}
.crs2-arrow:hover { border-color: var(--color-teal); color: var(--color-teal); }
.crs2-dots {
  display: flex;
  align-items: center;
  gap: 8px;
}
.crs2-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  background: rgba(7,30,48,0.18);
  border: none; padding: 0; cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}
.crs2-dot--active {
  background: var(--color-gold);
  transform: scale(1.35);
}

/* ── USP ── */
.hp-usp__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
}
.hp-usp-item { display: flex; flex-direction: column; align-items: flex-start; }
.hp-usp-item__icon {
  width: 48px; height: 48px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(31,111,95,0.1);
  color: var(--color-teal);
  margin-bottom: 20px;
}
.hp-usp-item__title {
  font-family: var(--font-serif);
  font-size: 1.1rem; font-weight: 400;
  color: var(--color-midnight);
  margin-bottom: 8px;
}
.hp-usp-item__text { font-size: 13px; color: var(--color-slate); line-height: 1.7; }

/* ── Halong cinematic banner ── */
.hp-halong {
  position: relative;
  width: 100%;
  height: clamp(480px, 55vw, 680px);
  overflow: hidden;
}
.hp-halong__img {
  position: absolute; inset: 0;
  width: 100%; height: 100%;
  object-fit: cover;
  object-position: center 60%;
  display: block;
}
.hp-halong__img-fallback {
  position: absolute; inset: 0;
  background: linear-gradient(135deg, #071E30 0%, #0B3250 60%, #1a4a6e 100%);
}
.hp-halong__overlay {
  position: absolute; inset: 0;
  background: linear-gradient(
    to right,
    rgba(7,30,48,0.82) 0%,
    rgba(7,30,48,0.55) 40%,
    rgba(7,30,48,0.10) 70%,
    rgba(7,30,48,0)    100%
  );
}
.hp-halong__content {
  position: absolute; inset: 0;
  display: flex; align-items: center;
}
.hp-halong__text {
  max-width: 520px;
}
.hp-halong__text .hp-eyebrow { color: var(--color-gold); }
.hp-halong__text .hp-title   { color: var(--color-ivory); margin-bottom: 0; }
.hp-halong__text .hp-divider { background: var(--color-gold); opacity: 0.5; }
.hp-split__body {
  font-size: 14px; color: rgba(245,242,236,0.78);
  line-height: 1.85; margin-bottom: 28px;
}
@media (max-width: 768px) {
  .hp-halong {
    height: auto;
    display: flex; flex-direction: column;
  }
  .hp-halong__img, .hp-halong__img-fallback {
    position: relative; inset: unset;
    width: 100%; height: 260px;
    flex-shrink: 0;
  }
  .hp-halong__overlay {
    background: linear-gradient(
      to bottom,
      rgba(7,30,48,0)   0%,
      rgba(7,30,48,0.65) 100%
    );
  }
  .hp-halong__content {
    position: relative; inset: unset;
    background: var(--color-midnight);
    padding: 40px 24px 48px;
    align-items: flex-start;
  }
  .hp-split__body { color: rgba(245,242,236,0.7); }
}

/* ── Itineraries ── */
.hp-itin__header {
  display: flex; align-items: flex-end; justify-content: space-between;
  gap: 24px; margin-bottom: 0;
}
.hp-itin__nav { display: flex; gap: 8px; flex-shrink: 0; padding-bottom: 4px; }
.hp-itin__btn {
  width: 40px; height: 40px;
  display: flex; align-items: center; justify-content: center;
  border: 1px solid var(--color-teal-divider);
  background: transparent; color: var(--color-slate);
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}
.hp-itin__btn:hover { border-color: var(--color-teal); color: var(--color-teal); }

.hp-itin__carousel {
  display: flex;
  gap: 24px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  margin-top: 40px;
}
.hp-itin__carousel::-webkit-scrollbar { display: none; }

.hp-itin-card {
  flex: 0 0 calc((100% - 48px) / 3);
  min-width: 0;
  scroll-snap-align: start;
  display: flex; flex-direction: column;
  text-decoration: none; color: inherit;
  background: var(--color-white);
  border: 1px solid var(--color-divider);
  border-radius: 6px;
  overflow: hidden;
  transition: border-color 0.25s, box-shadow 0.25s;
}
.hp-itin-card:hover {
  border-color: var(--color-teal-divider);
  box-shadow: 0 4px 20px rgba(11,50,80,0.08);
}
.hp-itin-card:hover .hp-itin-card__arrow { gap: 10px; }
.hp-itin-card__thumb {
  aspect-ratio: 16/9; overflow: hidden;
  background: var(--color-midnight);
}
.hp-itin-card__img {
  width: 100%; height: 100%;
  object-fit: cover; display: block;
  transition: transform 0.5s ease;
}
.hp-itin-card:hover .hp-itin-card__img { transform: scale(1.04); }
.hp-itin-card__body { padding: 24px; flex: 1; display: flex; flex-direction: column; gap: 8px; }
.hp-itin-card__cruise {
  font-size: 9px; font-weight: 500; letter-spacing: 0.18em;
  text-transform: uppercase; color: var(--color-gold);
}
.hp-itin-card__name {
  font-family: var(--font-serif); font-size: 1.2rem; font-weight: 400;
  color: var(--color-midnight); line-height: 1.3;
}
.hp-itin-card__excerpt {
  font-size: 14px; color: var(--color-slate);
  line-height: 1.65; flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.hp-itin-card__meta {
  display: flex; flex-wrap: wrap; gap: 10px;
  margin-top: 4px;
}
.hp-itin-card__meta-item {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 11px; letter-spacing: 0.05em;
  color: var(--color-slate);
}
.hp-itin-card__meta-item svg { color: var(--color-teal); flex-shrink: 0; }
.hp-itin-card__arrow {
  font-size: 10px; font-weight: 500; letter-spacing: 0.1em;
  text-transform: uppercase; color: var(--color-teal);
  display: inline-flex; align-items: center; gap: 6px;
  transition: gap 0.2s; margin-top: 8px;
}
@media (max-width: 900px) {
  .hp-itin-card { flex: 0 0 calc((100% - 24px) / 2); }
}
@media (max-width: 540px) {
  .hp-itin-card { flex: 0 0 85%; }
}

/* ── Activities ── */
.hp-act-section { padding: 96px 0; }
.hp-act__header {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 24px; margin-bottom: 40px;
}
.hp-act__nav { display: flex; gap: 8px; padding-top: 4px; flex-shrink: 0; }

.hp-act__carousel {
  display: flex; gap: 24px;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}
.hp-act__carousel::-webkit-scrollbar { display: none; }

.hp-act-card {
  flex: 0 0 calc((100% - 48px) / 3);
  min-width: 0;
  cursor: pointer;
  background: var(--color-white);
  border: 1px solid var(--color-divider);
  border-radius: 6px;
  overflow: hidden;
  transition: border-color 0.25s, box-shadow 0.25s;
}
.hp-act-card:hover {
  border-color: var(--color-teal-divider);
  box-shadow: 0 4px 20px rgba(11,50,80,0.08);
}
.hp-act-card__img {
  aspect-ratio: 4/3; overflow: hidden;
  background: var(--color-midnight);
}
.hp-act-card__img img {
  width: 100%; height: 100%;
  object-fit: cover; display: block;
  transition: transform 0.5s ease;
}
.hp-act-card:hover .hp-act-card__img img { transform: scale(1.05); }
.hp-act-card__mock-icon {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  color: rgba(255,255,255,0.55);
}
.hp-act-card__body { padding: 18px 20px; }
.hp-act-card__cat {
  display: block;
  font-size: 9px; font-weight: 500; letter-spacing: 0.18em;
  text-transform: uppercase; color: var(--color-gold); margin-bottom: 6px;
}
.hp-act-card__title {
  font-family: var(--font-serif); font-size: 1.15rem; font-weight: 400;
  color: var(--color-midnight); line-height: 1.3; margin: 0;
}

/* Activity modal */
.hp-act-modal__backdrop {
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(7,30,48,0.72);
  display: flex; align-items: center; justify-content: center;
  padding: 24px;
}
.hp-act-modal {
  position: relative;
  width: 100%; max-width: 800px;
  background: var(--color-white);
  overflow: hidden;
}
.hp-act-modal__close {
  position: absolute; top: 12px; right: 12px; z-index: 2;
  width: 32px; height: 32px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(7,30,48,0.55); color: white;
  border: none; cursor: pointer;
  transition: background 0.2s;
}
.hp-act-modal__close:hover { background: rgba(7,30,48,0.9); }
.hp-act-modal__img-wrap {
  position: relative; aspect-ratio: 16/9; overflow: hidden;
}
.hp-act-modal__img { width: 100%; height: 100%; object-fit: cover; display: block; }
.hp-act-modal__mock-icon {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  color: rgba(255,255,255,0.5);
}
.hp-act-modal__nav {
  position: absolute; top: 50%; transform: translateY(-50%);
  background: rgba(7,30,48,0.55); color: white;
  border: none; cursor: pointer;
  width: 36px; height: 36px;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.2s; z-index: 1;
}
.hp-act-modal__nav:hover { background: rgba(7,30,48,0.88); }
.hp-act-modal__nav--prev { left: 10px; }
.hp-act-modal__nav--next { right: 10px; }
.hp-act-modal__counter {
  position: absolute; bottom: 10px; right: 12px;
  font-size: 10px; letter-spacing: 0.08em;
  color: rgba(255,255,255,0.75);
}
.hp-act-modal__body { padding: 24px 28px 28px; display: flex; flex-direction: column; gap: 8px; }
.hp-act-modal__tag {
  font-family: var(--font-sans);
  font-size: 9px; font-weight: 500; letter-spacing: 0.18em;
  text-transform: uppercase; color: var(--color-gold);
}
.hp-act-modal__title {
  font-family: var(--font-serif); font-size: 1.55rem; font-weight: 400;
  color: var(--color-midnight); margin: 0;
}
.hp-act-modal__desc {
  font-size: 14px; line-height: 1.7;
  color: var(--color-slate); margin: 4px 0 0;
}

@media (max-width: 900px) {
  .hp-act-card { flex: 0 0 calc((100% - 24px) / 2); }
}
@media (max-width: 540px) {
  .hp-act-card { flex: 0 0 80%; }
}

/* ── Testimonials ── */
.hp-testi-section { padding: 96px 0; }
.hp-testi__nav {
  display: flex; gap: 8px;
  margin-top: 28px;
}

.hp-testi__carousel {
  display: flex; gap: 24px;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}
.hp-testi__carousel::-webkit-scrollbar { display: none; }

.hp-testi-card {
  flex: 0 0 calc((100% - 48px) / 3);
  min-width: 0;
  background: var(--color-white);
  border: 1px solid var(--color-divider);
  border-radius: 6px;
  padding: 28px;
  display: flex; flex-direction: column; gap: 16px;
}

.hp-testi-card__stars { display: flex; gap: 3px; }

.hp-testi-card__quote {
  font-family: var(--font-serif);
  font-size: 1rem; font-style: italic; font-weight: 300;
  color: var(--color-midnight); line-height: 1.8; flex: 1;
  display: -webkit-box; -webkit-line-clamp: 5; -webkit-box-orient: vertical; overflow: hidden;
}

.hp-testi-card__footer {
  display: flex; align-items: center; justify-content: space-between;
  gap: 12px; padding-top: 16px;
  border-top: 1px solid var(--color-divider);
}

.hp-testi-card__ota { width: 100px; height: 28px; flex-shrink: 0; display: flex; align-items: center; }
.hp-testi-card__ota-img { width: 100%; height: 100%; object-fit: contain; object-position: left center; display: block; }
.hp-testi-card__ota-text {
  font-size: 10px; font-weight: 600; letter-spacing: 0.08em;
  text-transform: uppercase; color: var(--color-slate);
}

.hp-testi-card__author {
  display: flex; flex-direction: column; align-items: flex-end; gap: 2px;
}
.hp-testi-card__name {
  font-family: var(--font-sans);
  font-size: 12px; font-weight: 600;
  color: var(--color-midnight); letter-spacing: 0.02em;
}
.hp-testi-card__nat {
  font-size: 11px; color: var(--color-slate);
}

@media (max-width: 900px) {
  .hp-testi-card { flex: 0 0 calc((100% - 24px) / 2); }
}
@media (max-width: 540px) {
  .hp-testi-card { flex: 0 0 85%; }
}

/* ── Blog ── */
.hp-blog__header {
  display: flex; align-items: flex-end; justify-content: space-between;
  gap: 24px; margin-bottom: 40px; flex-wrap: wrap;
}
.hp-blog__nav { display: flex; gap: 8px; flex-shrink: 0; padding-bottom: 4px; }
.hp-blog__footer {
  display: flex; justify-content: center;
  margin-top: 40px;
}

.hp-blog__carousel {
  display: flex;
  gap: 28px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.hp-blog__carousel::-webkit-scrollbar { display: none; }

.hp-blog-card {
  flex: 0 0 calc((100% - 56px) / 3);
  min-width: 0;
  scroll-snap-align: start;
  display: flex; flex-direction: column;
  text-decoration: none; color: inherit;
  background: var(--color-white); overflow: hidden;
  border-radius: 6px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.hp-blog-card:hover { transform: translateY(-4px); box-shadow: 0 12px 32px rgba(7,30,48,0.1); }
.hp-blog-card__thumb { aspect-ratio: 16/9; overflow: hidden; }
.hp-blog-card__body { padding: 20px; flex: 1; display: flex; flex-direction: column; }
.hp-blog-card__cat {
  font-size: 10px; font-weight: 500; letter-spacing: 0.16em;
  text-transform: uppercase; color: var(--color-teal); margin-bottom: 8px;
}
.hp-blog-card__title {
  font-family: var(--font-serif); font-size: 1.1rem; font-weight: 400;
  color: var(--color-midnight); margin-bottom: 8px; line-height: 1.35;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.hp-blog-card__excerpt {
  font-size: 13px; color: var(--color-slate); line-height: 1.65;
  flex: 1; margin-bottom: 16px;
  display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;
}
.hp-blog-card__date { font-size: 11px; color: var(--color-slate); opacity: 0.7; }

/* ── FAQ ── */
.hp-faq-section { padding: 96px 0; background: var(--color-ivory); }
.hp-faq__inner {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 80px;
  align-items: start;
}
.hp-faq__left { position: sticky; top: 100px; }
.hp-faq__left .hp-divider { margin-bottom: 20px; }
.hp-faq__sub {
  font-family: var(--font-sans);
  font-size: 14px; font-weight: 300;
  color: var(--color-slate);
  line-height: 1.7; margin-bottom: 32px;
}
.hp-faq__right { display: flex; flex-direction: column; gap: 0; }
.hp-faq-item {
  border-bottom: 1px solid rgba(7,30,48,0.1);
}
.hp-faq-item:first-child { border-top: 1px solid rgba(7,30,48,0.1); }
.hp-faq-item__q {
  display: flex; align-items: center; justify-content: space-between;
  gap: 16px;
  padding: 20px 0;
  cursor: pointer;
  background: none; border: none;
  width: 100%; text-align: left;
}
.hp-faq-item__q-text {
  font-family: var(--font-mono);
  font-size: 1.1rem; font-weight: 400;
  color: var(--color-midnight);
  line-height: 1.35;
}
.hp-faq-item__q-icon {
  flex-shrink: 0;
  width: 24px; height: 24px;
  display: flex; align-items: center; justify-content: center;
  color: var(--color-teal);
  transition: transform 0.28s ease;
}
.hp-faq-item--open .hp-faq-item__q-icon { transform: rotate(45deg); }
.hp-faq-item__a {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.35s ease, padding 0.35s ease;
  padding: 0 0 0;
}
.hp-faq-item--open .hp-faq-item__a {
  max-height: 600px;
  padding: 0 0 20px;
}
.hp-faq-item__a-text {
  font-family: var(--font-sans);
  font-size: 15px; font-weight: 300;
  color: var(--color-midnight);
  line-height: 1.5;
  white-space: pre-line;
}
@media (max-width: 860px) {
  .hp-faq__inner { grid-template-columns: 1fr; gap: 40px; }
  .hp-faq__left { position: static; }
}

/* ── Responsive ── */
@media (max-width: 1100px) {
  .hp-usp__grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 900px) {
  .hp-section { padding: 72px 0; }
  .hp-inner { padding: 0 12px; }
  .hp-testimonials__grid { grid-template-columns: 1fr; }
  .hp-blog-card { flex: 0 0 calc((100% - 28px) / 2); }
}
@media (max-width: 600px) {
  .hp-usp__grid { grid-template-columns: 1fr; }
  .hp-blog-card { flex: 0 0 85%; }
  .hp-hero__title { font-size: 2.4rem; }
  .hp-hero__dots { bottom: 24px; right: 24px; }
}
`
